const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')
const {
  DAMAGE_BLUDGEONING,
  DAMAGE_COLD,
  DAMAGE_FIRE,
  DAMAGE_NONMAGIC_WEAPON,
  DAMAGE_PIERCING,
} = require('./../../../../damageTypeList')
const {
  ATTACK_MELEE_WEAPON,
  ATTACK_RANGE_WEAPON,
} = require('./../../../../attackTypeList')
const {ABILITY_HEATED_BODY} = require('./../../../../creatureAbilityList')
const {ALIGNMENT_NE} = require('./../../../../aligmentList')
const {ARMOR_TYPE_NATURAL} = require('./../../../../armorTypeList')
const {CR_5} = require('./../../../../crList')
const {CREATURE_SALAMANDER} = require('./../../../../creatureIdList')
const {CREATURE_TYPE_ELEMENTAL} = require('./../../../../creatureTypeIdList')
const {GENDER_FEMALE} = require('./../../../../genderList')
const {LANG_IGNAN} = require('./../../../../languageIdList')
const {salamanderDescriptionList} = require('./../../../../textCommonParts')
const {SENSE_DARK_VISION} = require('./../../../../senseList')
const {SIZE_LARGE} = require('./../../../../sizeList')
const {SOURCE_MM} = require('./../../../../sourceList')
const {SPEED_WALK} = require('./../../../../speedList')

module.exports = {
  name: 'Саламандра',
  nameEn: 'Salamander',
  id: CREATURE_SALAMANDER,
  description: salamanderDescriptionList,
  sizeType: SIZE_LARGE,
  creatureTypeIdList: [
    CREATURE_TYPE_ELEMENTAL,
  ],
  alignmentId: ALIGNMENT_NE,
  source: {
    id: SOURCE_MM,
    page: 255,
  },
  armor: {
    ac: 15,
    type: ARMOR_TYPE_NATURAL,
  },
  hp: {
    diceCount: 12,
  },
  speed: {
    [SPEED_WALK]: 30,
  },
  params: {
    [PARAM_STR]: 18,
    [PARAM_DEX]: 14,
    [PARAM_CON]: 15,
    [PARAM_INT]: 11,
    [PARAM_WIT]: 10,
    [PARAM_CHA]: 12,
  },
  vulnerabilityList: [
    DAMAGE_COLD,
  ],
  resistanceList: [
    DAMAGE_NONMAGIC_WEAPON,
  ],
  immunityList: [
    DAMAGE_FIRE,
  ],
  senseList: [
    {
      id: SENSE_DARK_VISION,
      value: 60,
    },
  ],
  languageList: [
    LANG_IGNAN,
  ],
  cr: CR_5,
  featureList: [
    {
      id: ABILITY_HEATED_BODY,
      damage: `7 (2к6)`,
    },
    {
      name: `Раскалённое оружие`,
      description: `Всё металлическое рукопашное оружие, которое использует ★СУЩЕСТВО★, причиняет дополнительный урон огнём 3 (1к6) при попадании (уже учтено в атаках).`,
    },
  ],
  actionList: [
    {
      name: `Мультиатака`,
      description: `★СУЩЕСТВО★ совершает две атаки: одну _Копьём_, и одну _Хвостом_.`,
    },
    {
      name: `Копьё`,
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: 7,
        range: 5,
        hit: [
          [
            {
              type: DAMAGE_PIERCING,
              diceCount: 2,
              diceType: 6,
              diceBonus: 4,
            },
            {
              type: DAMAGE_PIERCING,
              diceCount: 2,
              diceType: 8,
              diceBonus: 4,
              use2Hand: true,
            },
          ],
          {
            type: DAMAGE_FIRE,
            diceCount: 1,
            diceType: 6,
            diceBonus: 0,
          },
        ],
      },
    },
    {
      name: `Копьё`,
      attack: {
        type: ATTACK_RANGE_WEAPON,
        bonus: 7,
        range: {
          normal: 20,
          max: 60,
        },
        hit: [
          {
            type: DAMAGE_PIERCING,
            diceCount: 2,
            diceType: 6,
            diceBonus: 4,
          },
          {
            type: DAMAGE_FIRE,
            diceCount: 1,
            diceType: 6,
            diceBonus: 0,
          },
        ],
      },
    },
    {
      name: `Хвост`,
      description: `Цель становится схваченной (СЛ высвобождения 14). Пока цель схвачена, она обездвижена, ★СУЩЕСТВО★ может автоматически попадать по ней хвостом, и не может совершать атаки хвостом по другим целям.`,
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: 7,
        range: 10,
        hit: [
          {
            type: DAMAGE_BLUDGEONING,
            diceCount: 2,
            diceType: 6,
            diceBonus: 4,
          },
          {
            type: DAMAGE_FIRE,
            diceCount: 2,
            diceType: 6,
            diceBonus: 0,
          },
        ],
      },
    },
  ],
  genderId: GENDER_FEMALE,
}
